import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  class: "page-bar ep-bar",
  ref: "bar"
}
const _hoisted_2 = { class: "pb-detail" }
const _hoisted_3 = { class: "page-bar-sub" }
const _hoisted_4 = { class: "pb-title" }
const _hoisted_5 = { class: "page-bar-main" }
const _hoisted_6 = { class: "dbadge st-draft" }
const _hoisted_7 = {
  key: 0,
  class: "ep-unsaved"
}
const _hoisted_8 = { class: "pb-actions ep-actions" }
const _hoisted_9 = {
  key: 0,
  class: "ep-vsep"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          class: "pb-crumb",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('cancel')), ["prevent"]))
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
            _createElementVNode("path", { d: "M19 12H5M11 18l-6-6 6-6" })
          ], -1)),
          _createTextVNode("Back to " + _toDisplayString(_ctx.typeLabel), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.name || 'Untitled ' + _ctx.typeLabel), 1),
        _createElementVNode("span", _hoisted_6, "Editing v" + _toDisplayString(_ctx.version), 1),
        (_ctx.dirty)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("i", null, null, -1),
              _createTextVNode("Unsaved changes", -1)
            ]))]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _renderSlot(_ctx.$slots, "default"),
      (_ctx.$slots.default)
        ? (_openBlock(), _createElementBlock("span", _hoisted_9))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "btn-light pb-btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel')))
      }, "Cancel"),
      _createElementVNode("button", {
        type: "button",
        class: "btn pb-btn",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('save')))
      }, [...(_cache[5] || (_cache[5] = [
        _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
          _createElementVNode("path", { d: "M5 3h11l5 5v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zM7 3v5h8V3M7 21v-7h10v7" })
        ], -1),
        _createElementVNode("span", null, "Save", -1)
      ]))])
    ])
  ], 512))
}